import { ViewRepresentativesStatusComponent } from '../view-representatives/view-representatives-status/view-representatives-status.component';
import { VsmControlComponent } from './vsm-control/vsm-control.component';
import { Component, OnInit } from '@angular/core';
import { ApiDataSource } from 'app/datasources/api.datasrouce';
import { IAccount } from 'app/store/models/account.model';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import {
  EFilterType,
  ETableColumnType,
  ITableColumn,
  ITableFIlterGroup,
  ITableMassiveAction,
} from 'app/store/models/table.model';
import { ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { AccountService } from 'app/store/services/account.service';
import { forkJoin, of, Subject } from 'rxjs';
import { PartnerControlComponent } from './partner-control/partner-control.component';
import { FranchiseeControlComponent } from './franchisee-control/franchisee-control.component';
import { ReferralPartnerControlComponent } from './referral-partner-control/referral-partner-control.component';
import { LeftMenuService } from 'app/store/services/left-menu.service';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { UserService } from 'app/store/services/user.service';
import { Store } from '@ngrx/store';
import { IReducers } from '../../store/reducers';
import { SessionService } from '../../store/services/session.service';
import { openDialog, openSnackbar } from '../../store/actions/page.action';
import * as moment from 'moment';
import { EditAccountComponent } from './edit-account/edit-account.component';
import { ChangeAccountPasswordComponent } from './change-account-password/change-account-password.component';
import { SetNotificationEmailComponent } from './set-notification-email/set-notification-email.component';
import { SetContactLimitComponent } from './set-contact-limit/set-contact-limit.component';
import { SetSendLimitComponent } from './set-send-limit/set-send-limit.component';
import {
  EmailsSuspendStatesMap,
  stateToValue,
  SuspendEmailsComponent,
} from './suspend-emails/suspend-emails.component';
import { init } from '../../store/actions/user.action';
import { IVsmGroup } from '../../store/models/vsm.model';
import { UserType } from '../../store/models/user.model';
import { WebSocketService } from '../../store/services/web-socket.service';
import {
  ManagerSelectDialogComponent,
  SUBSCRIPTION_PAID_BY_MANAGER,
} from './manager-select-dialog/manager-select-dialog.component';
import { ConfigureReportsDialogComponent } from './configure-reports-dialog/configure-reports-dialog.component';
import { ConfirmedAtComponent } from './confirmed-at/confirmed-at.component';
import { ManageSubscriptionDialogComponent } from './manage-subscription-dialog/manage-subscription-dialog.component';
import { DialogComponent } from '../../shared/ui/dialog/dialog.component';
import { SubscriptionService } from '../../store/services/subscription.service';
import { IUserSessionData } from 'app/store/models/user.model'
import { ManageDeletedAccountComponent } from 'app/dialogs/manage-deleted-account/manage-deleted-account.component';
import { FranchiseeService } from 'app/franchisee/franchisee.service';
import { IReferralPartner } from 'app/store/models/franchisee.model';

@Component({
  selector: 'app-list-accounts',
  templateUrl: './list-accounts.component.html',
  styleUrls: ['./list-accounts.component.scss'],
})
export class ListAccountsComponent implements OnInit {
  dataSource: ApiDataSource<IAccount>;
  tableColumns: ITableColumn<IAccount>[] = [];
  tableReady$: Subject<boolean> = new Subject<boolean>();

  managers: IAccount[];
  partners: IAccount[];
  franchisees: IAccount[];
  vsms: IVsmGroup[];
  referralPartners: IReferralPartner[] = [];
  sessionFranchiseeId: number | null = null;
  tableDataSourceParams = {
    page: 1,
    pageSize: 10,
    sortAttr: 'account_id',
    sortDir: 'desc',
    filters: {},
  };

  tableFilterGroups: ITableFIlterGroup[] = [
    {
      filters: [
        {
          type: EFilterType.SEARCH,
          label: 'Search',
          items: [
            {
              id: 'search',
              label: 'Search...',
            },
          ],
        },
        {
          type: EFilterType.SELECT,
          id: 'filter',
          label: 'User Role',
          items: [
            {
              id: 'user_type',
              label: 'All',
              value: 'reset',
              resetOtherFilters: true,
            },
            {
              id: 'user_type',
              label: 'Manager',
              value: 'manager',   
            },
            {
              id: 'user_type',
              label: 'Partner',
              value: 'partner',
            },
            {
              id: 'user_type',
              label: 'VSM',
              value: 'vsm',
            },
            {
              id: 'user_type',
              label: 'User',
              value: 'user',
            },
            {
              id: 'user_type',
              label: 'Admin',
              value: 'master',
            },
            {
              id: 'user_type',
              label: 'Franchisee',
              value: 'franchisee',
            }
          ]
        },
        {
          type: EFilterType.SELECT,
          id: 'filter',
          label: 'Filter by...',
          items: [
            {
              id: 'filter',
              label: 'Any',
              value: 'any',
            },
            {
              id: 'filter',
              label: 'No Match (older than 5 days)',
              value: 'no_match',
            },
            {
              id: 'filter',
              label: '<250 (less than 250 contacts)',
              value: '<250',
            },
            {
              id: 'filter',
              label: '<500 (less than 500 contacts)',
              value: '<500',
            },
            {
              id: 'filter',
              label: '>10 Messages (more than 10 messages in inbox)',
              value: '>10',
            },
            {
              id: 'filter',
              label: 'No Campaign (No Active or any Campaign in Account)',
              value: 'no_campaign',
            },
          ],
        },
      ],
    },
  ];

  tableMassiveActions: ITableMassiveAction<IAccount>[] = [
    {
      label: 'Send One-time Message',
      handler: accounts => {
      },
    },
  ];
  private adminActionsLabelMap = {
    switch: 'Switch to Account',
    export: 'Export user contacts',
    allowExportOn: 'Allow user export',
    allowExportOff: 'Disallow user export',
    enableRecruit: 'Enable C2Recruit',
    disableRecruit: 'Disable C2Recruit',
    confirm: 'Confirm user',
    confirmAndMark: 'Confirm and mark invoiced',
    edit: 'Edit user details',
    changePassword: 'Change user password',
    notificationEmail: 'Set Notification email address',
    contactLimit: 'Set contact limit',
    sendLimit: 'Set Send limit',
    enableEmails: 'Suspend emails',
    enableInbox: 'Enable Inbox Management',
    disableInbox: 'Disable Inbox Management',
    releaseToggleOn: 'Enable EDGE release content',
    releaseToggleOff: 'Disable EDGE release content',
    checkUserEmailDomainOn: 'Enable Check user email domain',
    checkUserEmailDomainOff: 'Disable Check user email domain',
    enableApiKeys: 'Enable API keys',
    disableApiKeys: 'Disable API keys',
    enableReports: 'Enable reports',
    disableReports: 'Disable reports',
    markNotInvoiced: 'Mark not invoiced',
  };
  private allowedActions: string[] = [
    'disableInbox',
    'enableInbox',
    'enableEmails',
    'stopEmails',
    'unSuspendCampaigns',
    'suspendCampaigns',
    'sendLimit',
    'contactLimit',
    'notificationEmail',
    'changePassword',
    'edit',
    'confirm',
    'confirmAndMark',
    'switch',
    'oneTimeOn',
    'oneTimeOff',
    'enableRecruit',
    'disableRecruit',
    'export',
    'allowExportOn',
    'allowExportOff',
    'releaseToggleOn',
    'releaseToggleOff',
    'checkUserEmailDomainOn',
    'checkUserEmailDomainOff',
    'enableApiKeys',
    'disableApiKeys',
    'enableReports',
    'disableReports',
    'markNotInvoiced',
  ];
  private actionsMap: { [key: string]: string } = {
    enableEmails: 'enableEmails',
    stopEmails: 'enableEmails',
    unSuspendCampaigns: 'enableEmails',
    suspendCampaigns: 'enableEmails',
  };

  constructor(
    private http: HttpClient,
    private accountService: AccountService,
    private lefMenuService: LeftMenuService,
    private router: Router,
    private userService: UserService,
    private sessionService: SessionService,
    private store$: Store<IReducers>,
    private readonly wsService: WebSocketService,
    private readonly subscriptionService: SubscriptionService,
    private readonly franchiseeService: FranchiseeService,
  ) {
    this.dataSource = new ApiDataSource<IAccount>(
      this.http,
      environment.apiUrl + '/v1/users',
    );
  }

  getRowColor = (row: IAccount) => {
    if (row.actions.indexOf('unSuspendCampaigns') > -1 && row.actions.indexOf('stopEmails') > -1) {
      return 'alert-warning';
    }

    if (row.actions.indexOf('enableEmails') > -1) {
      return 'alert-danger';
    }

    return null;
  };

  ngOnInit() {
    this.sessionService.onReady().subscribe(session => {
      if(session && session.user_type === UserType.MASTER && session.id !== 1){
        this.tableFilterGroups[0].filters[1].items = this.tableFilterGroups[0].filters[1].items.filter(item => item.value !== 'master');
      }

      if (session && session.user_type === UserType.PARTNER) {
        this.tableFilterGroups[0].filters = this.tableFilterGroups[0].filters.filter(filter => filter.label !== 'User Role');
      } 
      this.lefMenuService.expand('accounts');
      const managers = this.accountService.getManagers();
      const partners = this.accountService.getPartners();
      const franchisees = this.franchiseeService.listFranchisees();
      const vsms =
        session.user_type === UserType.PARTNER || session.user_type === UserType.FRANCHISE
          ? of({ items: [] })
          : this.accountService.getVSMs();
      const referralPartners =
        session.user_type === UserType.FRANCHISE
          ? this.franchiseeService.listActiveReferralPartners(session.id)
          : of({ items: [] as IReferralPartner[] });
      forkJoin([managers, partners, franchisees, vsms, referralPartners]).subscribe(results => {
        this.managers = results[0].items;
        this.partners = results[1].items;
        this.franchisees = results[2].items;
        this.vsms = results[3].items;
        this.referralPartners = results[4].items || [];
        this.sessionFranchiseeId =
          session.user_type === UserType.FRANCHISE ? session.id : null;

        this.tableColumns = [
          {
            id: 'name',
            title: 'Name',
            renderer: column => {
              return `${column.first_name} ${column.last_name}`;
            },
          },
          {
            id: 'email',
            title: 'email',
          },
          {
            id: 'account_id',
            title: 'ID',
          },
          {
            id: 'account_role',
            title: 'Role',
            renderer: row => {
              if (!row.account_role) {
                return 'User';
              }
              if (row.account_role === 'vsm') {
                return 'Edge';
              }
              return row.account_role[0].toUpperCase() + row.account_role.slice(1);
            },
          },
          {
            id: 'c2recruit',
            title: 'C2R',
            renderer: row => (row.c2recruit ? 'T' : 'F'),
          },
          {
            id: 'last_contacts_upload_at',
            title: 'Last Processed File',
            renderer: row => row.last_contacts_upload_at ? moment(row.last_contacts_upload_at).format('MM-DD-YYYY HH:mm:ss') : '',
          },
          {
            id: 'last_signin',
            title: 'Last-Login',
            sortable: true,
          },
          {
            id: 'confirmed_at',
            title: 'Confirmed',
            type: ETableColumnType.COMPONENT,
            componentProperties: {
              component: ConfirmedAtComponent,
              mapData: {
                confirmedAt: {
                  instance: 'column',
                  target: 'confirmed_at',
                },
                user: {
                  instance: 'static',
                  target: session,
                },
              },
            },
          },
          {
            id: 'status',
            title: 'Status',
            type: ETableColumnType.COMPONENT,
            hint: 'status_accounts',
            componentProperties: {
              component: ViewRepresentativesStatusComponent,
              mapData: {
                account: {
                  instance: 'column',
                },
              },
            },
          },
          {
            id: 'actions',
            title: 'Actions',
            type: ETableColumnType.SELECT,
            selectProperties: {
              label: 'Action',
              resetSelection: true,
              defaultValue: '',
              onSelection: value => {
                if (!value) {
                  return;
                }
                switch (value.action) {
                  case 'markNotInvoiced':
                    this.store$.dispatch(openDialog({
                      dialogData: {
                        content: `Do you want to mark the user ${value.row.email} as NOT invoiced?<br/>
<div class='alert alert-warning mt-3'>
If user is marked as invoiced -> no stripe subscription is required<br/>
If user is marked as invoiced -> the "update credit card" option is HIDDEN for the user when logged in (In menu My Account -> Manage -> There will be no "Update Credit Card" option<br/>
If user is marked as NOT invoiced -> stripe subscription is required<br/>
If user is marked as NOT invoiced -> the update credit card option is SHOWN for the user when logged in (In menu My Account -> Manage -> Update Credit Card"<br/>
Please note, if user is NOT invoiced the user should provide payment details AND select a retreva plan</div>`,
                        title: 'Mark ',
                        canClose: true,
                        buttons: [
                          {
                            text: 'Yes',
                            color: ButtonColor.RED,
                            size: ButtonSize.NORMAL,
                            onClick: (dialog) =>
                              this.accountService
                                .updateUserDetails(value.row.account_id, {
                                  invoiced: false,
                                }).subscribe(() => {
                                this.store$.dispatch(openSnackbar({
                                  snackbarData: {
                                    data: {
                                      message: 'User is unmarked as invoiced!',
                                      type: 'success',
                                    },
                                  },
                                }));
                                dialog.closeDialog();
                                this.dataSource.refresh();
                              }, err => {
                                this.store$.dispatch(openSnackbar({
                                  snackbarData: {
                                    data: {
                                      message: err.error,
                                      type: 'error',
                                    },
                                  },
                                }));
                                dialog.closeDialog();
                              }),
                          },
                        ],
                      },
                    }));
                    break;
                  case 'enableInbox':
                  case 'disableInbox':
                    this.accountService
                      .toggleAccountInboxSettings(value.row.account_id)
                      .subscribe(
                        response => {
                          if (response && response.success) {
                            this.store$.dispatch(
                              openSnackbar({
                                snackbarData: {
                                  data: {
                                    message: 'Inbox settings updated',
                                    type: 'success',
                                  },
                                },
                              }),
                            );
                            this.dataSource.refresh();
                          }
                        },
                        error =>
                          this.store$.dispatch(
                            openSnackbar({
                              snackbarData: {
                                data: {
                                  message: error.error,
                                  type: 'error',
                                },
                              },
                            }),
                          ),
                      );
                    break;
                  case 'stopEmails':
                  case 'suspendCampaigns':
                  case 'unSuspendCampaigns':
                  case 'enableEmails':
                    const componentDataState = stateToValue(
                      value.row.actions.indexOf('enableEmails') !== -1,
                      value.row.actions.indexOf('suspendCampaigns') !== -1,
                      value.row.actions.indexOf('unSuspendCampaigns') !== -1,
                      value.row.actions.indexOf('stopEmails') !== -1,
                    );
                    this.store$.dispatch(
                      openDialog({
                        dialogData: {
                          content: SuspendEmailsComponent,
                          title: 'Suspend Emails',
                          componentData: {
                            currentState: componentDataState,
                          },
                          buttons: [
                            {
                              text: 'Confirm',
                              onClick: dialog => {
                                const emailSuspendValue =
                                  EmailsSuspendStatesMap[
                                    dialog.dialogForm.value.enableEmails
                                    ];
                                this.accountService
                                  .changeAccountSetting(value.row.account_id, {
                                    suspend_emails: emailSuspendValue,
                                  })
                                  .subscribe(
                                    response => {
                                      this.store$.dispatch(
                                        openSnackbar({
                                          snackbarData: {
                                            data: {
                                              message:
                                                'Suspend emails\' settings successfully changed',
                                              type: 'success',
                                            },
                                          },
                                        }),
                                      );
                                      dialog.close();
                                      this.dataSource.refresh();
                                    },
                                    error =>
                                      this.store$.dispatch(
                                        openSnackbar({
                                          snackbarData: {
                                            data: {
                                              message: error.error,
                                              type: 'error',
                                            },
                                          },
                                        }),
                                      ),
                                  );
                              },
                              size: ButtonSize.SMALL,
                              color: ButtonColor.BLUE,
                            },
                          ],
                          canClose: true,
                          dialogMinWidth: '500px',
                        },
                      }),
                    );
                    break;
                  case 'enableReports':
                  case 'disableReports':
                    this.store$.dispatch(openDialog({
                      dialogData: {
                        content: ConfigureReportsDialogComponent,
                        title: `Configure reports access`,
                        componentData: {
                          account: value.row,
                        },
                        canClose: true,
                        dialogWidth: '700px',
                        buttons: [
                          {
                            text: 'Update',
                            color: ButtonColor.ORANGE,
                            size: ButtonSize.NORMAL,
                            onClick: dialog => {
                              if (!dialog.dialogForm.valid) {
                                dialog.dialogForm.markAllAsTouched();
                                return;
                              }

                              this.accountService.changeAccountSetting(value.row.account_id, dialog.dialogForm.value)
                                .subscribe(() => {
                                  this.store$.dispatch(openSnackbar({
                                    snackbarData: {
                                      data: {
                                        message: 'Account reports were succuessfully updated!',
                                        type: 'success',
                                      },
                                    },
                                  }));
                                  dialog.closeDialog();
                                  this.dataSource.refresh();
                                }, err => {
                                  this.store$.dispatch(openSnackbar({
                                    snackbarData: {
                                      data: {
                                        message: err.error,
                                        type: 'error',
                                      },
                                    },
                                  }));
                                });
                            },
                          },
                        ],
                      },
                    }));
                    break;
                  case 'sendLimit':
                    this.store$.dispatch(
                      openDialog({
                        dialogData: {
                          content: SetSendLimitComponent,
                          title: 'Please set Send Limit',
                          componentData: {
                            sendLimit: value.row.send_limit,
                          },
                          buttons: [
                            {
                              text: 'Confirm',
                              onClick: dialog => {
                                if (!dialog.dialogForm.valid) {
                                  dialog.dialogForm.markAllAsTouched();
                                  return;
                                }

                                this.accountService
                                  .changeAccountSetting(value.row.account_id, {
                                    send_limit: +dialog.dialogForm.value.limit,
                                  })
                                  .subscribe(
                                    response => {
                                      this.store$.dispatch(
                                        openSnackbar({
                                          snackbarData: {
                                            data: {
                                              message:
                                                'Send limit has been changed',
                                              type: 'success',
                                            },
                                          },
                                        }),
                                      );
                                      dialog.close();
                                      this.dataSource.refresh();
                                    },
                                    error =>
                                      this.store$.dispatch(
                                        openSnackbar({
                                          snackbarData: {
                                            data: {
                                              message: error.error,
                                              type: 'error',
                                            },
                                          },
                                        }),
                                      ),
                                  );
                              },
                              size: ButtonSize.SMALL,
                              color: ButtonColor.BLUE,
                            },
                          ],
                          canClose: true,
                        },
                      }),
                    );
                    break;
                  case 'contactLimit':
                    this.store$.dispatch(
                      openDialog({
                        dialogData: {
                          content: SetContactLimitComponent,
                          title: 'Please set Contact Limit',
                          componentData: {
                            accountId: value.row.account_id,
                            contactLimit: value.row.contact_record,
                          },
                          canClose: true,
                          dialogMinWidth: '500px',
                          buttons: [
                            {
                              text: 'Confirm',
                              onClick: dialog => {
                                if (!dialog.dialogForm.valid) {
                                  dialog.dialogForm.markAllAsTouched();
                                  return;
                                }

                                this.userService
                                  .updateBillingInfo(value.row.account_id, {
                                    contact_record:
                                    dialog.dialogForm.value.limit,
                                  })
                                  .subscribe(
                                    () => {
                                      dialog.closeDialog();
                                      this.dataSource.refresh();
                                      this.store$.dispatch(
                                        openSnackbar({
                                          snackbarData: {
                                            data: {
                                              message:
                                                'Contact Limit has been updated',
                                              type: 'success',
                                            },
                                          },
                                        }),
                                      );
                                    },
                                    error =>
                                      this.store$.dispatch(
                                        openSnackbar({
                                          snackbarData: {
                                            data: {
                                              message: error.error,
                                              type: 'error',
                                            },
                                          },
                                        }),
                                      ),
                                  );
                              },
                              size: ButtonSize.SMALL,
                              color: ButtonColor.BLUE,
                            },
                          ],
                        },
                      }),
                    );
                    break;
                  case 'notificationEmail':
                    this.store$.dispatch(
                      openDialog({
                        dialogData: {
                          content: SetNotificationEmailComponent,
                          title: 'Please set Notification Email',
                          componentData: {
                            accountId: value.row.account_id,
                            notificationEmail: value.row.notification_email,
                            notificationEnabled:
                            value.row.notification_email_enabled,
                            forwardEnabled: value.row.forward_email_enabled,
                            emailAddress: value.row.email,
                            data: {
                              tag: 'notification_email',
                            },
                          },
                          canClose: true,
                          dialogMinWidth: '500px',
                          buttons: [
                            {
                              text: 'Confirm',
                              onClick: dialog => {
                                if (!dialog.dialogForm.valid) {
                                  dialog.dialogForm.markAllAsTouched();
                                  return;
                                }
                                this.userService
                                  .setNotificationsEmail(
                                    value.row.account_id,
                                    dialog.dialogForm.value.emails,
                                    dialog.dialogForm.value.notification,
                                    dialog.dialogForm.value.forward,
                                  )
                                  .subscribe(
                                    result => {
                                      if (result.success) {
                                        dialog.close();
                                        this.dataSource.refresh();
                                        this.store$.dispatch(
                                          openSnackbar({
                                            snackbarData: {
                                              data: {
                                                message:
                                                  'Notification email successfully changed',
                                                type: 'success',
                                              },
                                            },
                                          }),
                                        );
                                      }
                                    },
                                    error => {
                                      this.store$.dispatch(
                                        openSnackbar({
                                          snackbarData: {
                                            data: {
                                              message: error.error,
                                              type: 'error',
                                            },
                                          },
                                        }),
                                      );
                                    },
                                  );
                              },
                              size: ButtonSize.SMALL,
                              color: ButtonColor.BLUE,
                            },
                          ],
                        },
                      }),
                    );
                    break;
                  case 'changePassword':
                    this.store$.dispatch(
                      openDialog({
                        dialogData: {
                          content: ChangeAccountPasswordComponent,
                          title: 'Edit Account',
                          componentData: {
                            accountId: value.row.account_id,
                          },
                          dialogMinWidth: '500px',
                          canClose: true,
                          buttons: [
                            {
                              text: 'Save',
                              onClick: dialog => {
                                if (!dialog.dialogForm.valid) {
                                  dialog.dialogForm.markAllAsTouched();
                                  return;
                                }

                                this.userService
                                  .resetPassword(
                                    value.row.account_id,
                                    dialog.dialogForm.value.password,
                                    dialog.dialogForm.value
                                      .password_confirmation,
                                  )
                                  .subscribe(
                                    response => {
                                      this.store$.dispatch(
                                        openSnackbar({
                                          snackbarData: {
                                            data: {
                                              message:
                                                'Account password successfully changed',
                                              type: 'success',
                                            },
                                          },
                                        }),
                                      );
                                      dialog.close();
                                      this.dataSource.refresh();
                                    },
                                    error =>
                                      this.store$.dispatch(
                                        openSnackbar({
                                          snackbarData: {
                                            data: {
                                              message: error.error,
                                              type: 'error',
                                            },
                                          },
                                        }),
                                      ),
                                  );
                              },
                              size: ButtonSize.SMALL,
                              color: ButtonColor.BLUE,
                            },
                          ],
                        },
                      }),
                    );
                    break;
                  case 'edit':
                    this.store$.dispatch(
                      openDialog({
                        dialogData: {
                          content: EditAccountComponent,
                          title: 'Edit Account',
                          componentData: {
                            accountId: value.row.account_id,
                          },
                          dialogMinWidth: '600px',
                          canClose: true,
                          buttons: [
                            {
                              text: 'Save',
                              onClick: dialog => {
                                if (!dialog.dialogForm.valid) {
                                  dialog.dialogForm.markAllAsTouched();
                                  return;
                                }

                                const data = dialog.dialogForm.value;

                                if(data.billing_grace_until){
                                  data.billing_grace_until = moment(data.billing_grace_until).format('YYYY-MM-DD HH:mm:ss');
                                }

                                this.userService
                                  .updateBillingInfo(
                                    value.row.account_id,
                                    data,
                                  )
                                  .subscribe(
                                    response => {
                                      this.store$.dispatch(
                                        openSnackbar({
                                          snackbarData: {
                                            data: {
                                              message:
                                                'Account updated successfully',
                                              type: 'success',
                                            },
                                          },
                                        }),
                                      );
                                      const accountData: IUserSessionData = value.row;

                                      if (accountData.email !== dialog.dialogForm.value.email){
                                        this.store$.dispatch(openDialog({
                                          dialogData: {
                                            title: 'Reset notification preferences',
                                            content: "You have changed the email address for this account. Do you want to reset the notification email preferences to default values?",
                                            canClose: true,
                                            closeButtonText: "No",
                                            onCloseButton: (dialog2) => {
                                              dialog2.close(); 
                                              dialog.close();
                                              this.dataSource.refresh();
                                            },
                                            onClose: () => {
                                              dialog.close();
                                              this.dataSource.refresh();
                                            },
                                            buttons: [
                                              {
                                                text: 'Yes',
                                                color: ButtonColor.BLUE,
                                                size: ButtonSize.NORMAL,
                                                onClick: (dialog2) => {
                                                  this.userService
                                                    .setNotificationsEmail(
                                                      value.row.account_id,
                                                      null,
                                                      false,
                                                      false,
                                                    )
                                                    .subscribe((result2) => {
                                                      if (result2.success) {
                                                        this.store$.dispatch(openSnackbar({
                                                          snackbarData: {
                                                            data: {
                                                              message: 'Notification preferences were reset to default values.',
                                                              type: 'success',
                                                            },
                                                          },
                                                        }))
                                                      }

                                                      dialog2.closeDialog();
                                                      dialog.closeDialog();
                                                      this.dataSource.refresh();
                                                    }, err => {
                                                      this.store$.dispatch(openSnackbar({
                                                        snackbarData: {
                                                          data: {
                                                            message: err.error,
                                                            type: 'error',
                                                          },
                                                        },
                                                      }));
                                                      dialog2.closeDialog();
                                                    });

                                                }
                                              }
                                            ]
                                          }
                                        }))
                                      } else {
                                        dialog.close();
                                        this.dataSource.refresh();
                                      }

                                    },
                                    error =>
                                      this.store$.dispatch(
                                        openSnackbar({
                                          snackbarData: {
                                            data: {
                                              message: error.error,
                                              type: 'error',
                                            },
                                          },
                                        }),
                                      ),
                                  );
                              },
                              size: ButtonSize.SMALL,
                              color: ButtonColor.BLUE,
                            },
                          ],
                        },
                      }),
                    );
                    break;
                  case 'confirm':
                  case 'confirmAndMark':
                    this.store$.dispatch(
                      openDialog({
                        dialogData: {
                          canClose: true,
                          content:
                            'Do you really want to' +
                            (value.action === 'confirmAndMark'
                              ? ' mark invoiced'
                              : ' confirm') +
                            ' user account ' +
                            value.row.account_id +
                            '?' + (value.action === 'confirmAndMark' ? `<div class='alert alert-warning mt-3'>
If user is marked as invoiced -> no stripe subscription is required<br/>
If user is marked as invoiced -> the "update credit card" option is HIDDEN for the user when logged in (In menu My Account -> Manage -> There will be no "Update Credit Card" option<br/>
If user is marked as NOT invoiced -> stripe subscription is required<br/>
If user is marked as NOT invoiced -> the update credit card option is SHOWN for the user when logged in (In menu My Account -> Manage -> Update Credit Card"<br/>
Please note, if user is NOT invoiced the user should provide payment details AND select a retreva plan</div>` : '')
                          ,
                          title:
                            (value.action === 'confirmAndMark' &&
                            value.row.confirmed_at
                              ? 'Mark invoiced'
                              : 'Confirm') +
                            ' user account',
                          buttons: [
                            {
                              text:
                                value.action === 'confirmAndMark' &&
                                value.row.confirmed_at
                                  ? 'Mark invoiced'
                                  : 'Confirm',
                              color: ButtonColor.BLUE,
                              actAsClose: true,
                              isCloseButton: true,
                              onClick: dialog => {
                                if (value.row.confirmed_at) {
                                  if (value.action === 'confirm') {
                                    this.store$.dispatch(
                                      openSnackbar({
                                        snackbarData: {
                                          data: {
                                            message:
                                              'User account ' +
                                              value.row.account_id +
                                              ' is already confirmed',
                                            type: 'danger',
                                          },
                                        },
                                      }),
                                    );
                                    return;
                                  }

                                  this.accountService
                                    .updateUserDetails(value.row.account_id, {
                                      invoiced: true,
                                    })
                                    .subscribe(
                                      response => {
                                        if (response && response.account_id) {
                                          this.store$.dispatch(
                                            openSnackbar({
                                              snackbarData: {
                                                data: {
                                                  message:
                                                    'User account ' +
                                                    value.row.account_id +
                                                    ' is confirmed and marked invoiced',
                                                  type: 'success',
                                                },
                                              },
                                            }),
                                          );
                                          this.dataSource.refresh();
                                        }
                                      },
                                      error =>
                                        this.store$.dispatch(
                                          openSnackbar({
                                            snackbarData: {
                                              data: {
                                                message: error.error,
                                                type: 'error',
                                              },
                                            },
                                          }),
                                        ),
                                    );
                                  return;
                                }
                                this.accountService
                                  .confirmUser(
                                    value.row.account_id,
                                    value.action === 'confirmAndMark',
                                  )
                                  .subscribe(
                                    () => {
                                      this.store$.dispatch(
                                        openSnackbar({
                                          snackbarData: {
                                            data: {
                                              message: 'User account confirmed',
                                              type: 'success',
                                            },
                                          },
                                        }),
                                      );
                                      this.dataSource.refresh();
                                      dialog.closeDialog();
                                    },
                                    error =>
                                      this.store$.dispatch(
                                        openSnackbar({
                                          snackbarData: {
                                            data: {
                                              message: error.error,
                                              type: 'error',
                                            },
                                          },
                                        }),
                                      ),
                                  );
                              },
                              size: ButtonSize.SMALL,
                            },
                          ],
                        },
                      }),
                    );
                    break;
                  case 'export':
                    this.accountService
                      .exportContacts(value.row.account_id, 'csv')
                      .subscribe(
                        (response: HttpResponse<Blob>) => {
                          const binaryData = [];
                          binaryData.push(response.body);
                          const downloadLink = document.createElement('a');
                          downloadLink.href = window.URL.createObjectURL(
                            new Blob(binaryData, { type: response.body.type }),
                          );

                          const filename = response.headers.get('content-disposition').split(';')[1].split('=')[1].replace(/\"/g, '');

                          downloadLink.setAttribute(
                            'download',
                            filename || `contacts_${moment().format('YYYY-MM-DD')}.csv`,
                          );
                          document.body.appendChild(downloadLink);
                          downloadLink.click();
                        },
                        error => this.store$.dispatch(openSnackbar({
                          snackbarData: {
                            data: {
                              message: error.error,
                              type: 'error',
                            }
                          }
                        })),
                      );
                    break;
                  case 'switch':
                    // close the ws if connected, it will be reopened later
                    if (this.wsService.connected) {
                      this.wsService.close();
                    }
                    this.accountService
                      .switchAccount(value.row.account_id)
                      .subscribe(response => {
                        localStorage.setItem('token', JSON.stringify(response));
                        this.store$.dispatch(init());
                        this.router.navigate(['/']);
                      });
                    break;
                  case 'releaseToggleOn':
                  case 'releaseToggleOff':
                    this.accountService.changeAccountSetting(value.row.account_id, {
                      release_toggle: value.action === 'releaseToggleOn',
                    }).subscribe(
                      result => {
                        if (result && result.setting) {
                          this.dataSource.refresh();
                          this.store$.dispatch(
                            openSnackbar({
                              snackbarData: {
                                data: {
                                  message: `EDGE release content has been turned ${
                                    value.action === 'releaseToggleOn'
                                      ? 'On'
                                      : 'Off'
                                  }`,
                                  type: 'success',
                                  button: {
                                    text: 'dismiss',
                                  },
                                },
                                verticalPosition: 'bottom',
                              },
                            }),
                          );
                        }
                      },
                      error =>
                        this.store$.dispatch(
                          openSnackbar({
                            snackbarData: {
                              data: {
                                type: 'error',
                                message: error.error,
                              },
                            },
                          }),
                        ),
                    );
                    break;
                  case 'checkUserEmailDomainOn':
                  case 'checkUserEmailDomainOff':
                    this.accountService.changeAccountSetting(value.row.account_id, {
                      check_user_email_domain: value.action === 'checkUserEmailDomainOn',
                    }).subscribe(
                      result => {
                        if (result && result.setting) {
                          this.dataSource.refresh();
                          this.store$.dispatch(
                            openSnackbar({
                              snackbarData: {
                                data: {
                                  message: `Check user email domain has been turned ${
                                    value.action === 'checkUserEmailDomainOn' ? 'On' : 'Off'
                                  }`,
                                  type: 'success',
                                },
                              },
                            }),
                          );
                        }
                      },
                      error =>
                        this.store$.dispatch(
                          openSnackbar({
                            snackbarData: {
                              data: {
                                type: 'error',
                                message: error.error,
                              },
                            },
                          }),
                        ),
                    );
                    break;
                  case 'enableApiKeys':
                  case 'disableApiKeys':
                    this.accountService.changeAccountSetting(value.row.account_id, {
                      api_keys_enabled: value.action === 'enableApiKeys',
                    }).subscribe(
                      result => {
                        if (result && result.setting) {
                          this.dataSource.refresh();
                          this.store$.dispatch(
                            openSnackbar({
                              snackbarData: {
                                data: {
                                  message: `API keys have been ${
                                    value.action === 'enableApiKeys' ? 'enabled' : 'disabled'
                                  }`,
                                  type: 'success',
                                },
                              },
                            }),
                          );
                        }
                      },
                      error =>
                        this.store$.dispatch(
                          openSnackbar({
                            snackbarData: {
                              data: {
                                type: 'error',
                                message: error.error,
                              },
                            },
                          }),
                        ),
                    );
                    break;
                  case 'enableRecruit':
                  case 'disableRecruit':
                    this.accountService
                      .changeAccountSetting(value.row.account_id, {
                        recruit: value.action === 'enableRecruit',
                      })
                      .subscribe(
                        result => {
                          if (result && result.setting) {
                            this.dataSource.refresh();
                            this.store$.dispatch(
                              openSnackbar({
                                snackbarData: {
                                  data: {
                                    message: `C2Recruit has been ${
                                      value.action === 'enableRecruit' ? 'enabled' : 'disabled'
                                    }`,
                                    type: 'success',
                                  },
                                },
                              }),
                            );
                          }
                        },
                        error =>
                          this.store$.dispatch(
                            openSnackbar({
                              snackbarData: {
                                data: {
                                  type: 'error',
                                  message: error.error,
                                },
                              },
                            }),
                          ),
                      );
                    break;
                  case 'allowExportOff':
                  case 'allowExportOn':
                    this.accountService
                      .updateUserDetails(value.row.account_id, {
                        export_contact: value.action === 'allowExportOn',
                      })
                      .subscribe(
                        result => {
                          if (result && result.account_id) {
                            this.dataSource.refresh();
                            this.store$.dispatch(
                              openSnackbar({
                                snackbarData: {
                                  data: {
                                    message: `Export contacts has turned ${
                                      value.action === 'allowExportOn'
                                        ? 'On'
                                        : 'Off'
                                    }`,
                                    type: 'success',
                                    button: {
                                      text: 'dismiss',
                                    },
                                  },
                                  verticalPosition: 'bottom',
                                },
                              }),
                            );
                          }
                        },
                        error =>
                          this.store$.dispatch(
                            openSnackbar({
                              snackbarData: {
                                data: {
                                  type: 'error',
                                  message: error.error,
                                },
                              },
                            }),
                          ),
                      );
                    break;
                  case 'oneTimeOn':
                  case 'oneTimeOff':
                    this.accountService
                      .changeAccountSetting(value.row.account_id, {
                        otm: value.action === 'oneTimeOn',
                      })
                      .subscribe(result => {
                        if (result && result.setting) {
                          this.dataSource.refresh();
                          this.store$.dispatch(
                            openSnackbar({
                              snackbarData: {
                                data: {
                                  message: `One time messages has turned ${
                                    value.action === 'oneTimeOn' ? 'On' : 'Off'
                                  }`,
                                  type: 'success',
                                  button: {
                                    text: 'dismiss',
                                  },
                                },
                                verticalPosition: 'bottom',
                              },
                            }),
                          );
                        }
                      });
                    break;
                  default:
                    console.log('DEFAULT');
                    break;
                }
              },
              buildItems: (row: IAccount) => {
                return [
                  '',
                  ...row.actions.filter(
                    a => this.allowedActions.indexOf(a) !== -1,
                  ),
                ]
                  .map(a => {
                    if (this.actionsMap[a]) {
                      return this.actionsMap[a];
                    }

                    return a;
                  })
                  .filter((a, index, arr) => arr.indexOf(a) === index)
                  .map(action => {
                    return {
                      label:
                        action === ''
                          ? 'Select an action...'
                          : this.getActionLabel(action, row),
                      value: action === '' ? action : { action, row },
                    };
                  });
              },
            },
          },
          {
            id: 'bounced',
            title: 'Bounced',
            type: ETableColumnType.BUTTON,
            disabled: session.user_type !== UserType.MASTER,
            buttonProperties: {
              text: 'Bounce',
              color: ButtonColor.BLUE,
              observeApi: true,
              buttonDisabled: (element: IAccount) => !(element.account_role === UserType.SINGLE_USER), 
              onClick: (element: IAccount) =>
                this.accountService
                  .downloadBouncedReport(element.account_id)
                  .subscribe(
                    response => {
                      const dataType = response.type;
                      const binaryData = [];
                      binaryData.push(response);
                      const downloadLink = document.createElement('a');
                      downloadLink.href = window.URL.createObjectURL(
                        new Blob(binaryData, { type: dataType }),
                      );

                      downloadLink.setAttribute(
                        'download',
                        `bounced_${moment().format('YYYY-MM-DD')}.csv`,
                      );
                      document.body.appendChild(downloadLink);
                      downloadLink.click();
                    },
                    error => {
                      this.store$.dispatch(
                        openSnackbar({
                          snackbarData: {
                            data: {
                              type: 'error',
                              message: error.error,
                            },
                          },
                        }),
                      );
                    },
                  ),
              size: ButtonSize.SMALL,
              style: 'outline',
            },
          },
          {
            id: 'delete',
            title: 'Delete',
            type: ETableColumnType.BUTTON,
            disabled: session.user_type !== UserType.MASTER,
            buttonProperties: {
              text: 'Delete',
              color: ButtonColor.RED,
              style: 'outline',
              onClick: (element: IAccount) => {
                if(element.account_role !== UserType.SINGLE_USER) {
                  let managerWarning = '';
                  if (element.account_role === UserType.MANAGER && element.visible_users.length > 0) {
                    managerWarning = '\n<div class="alert alert-danger"><p>You are deleting manager account associated with Users. The user assignments will be removed!</p></div>';
                  }
                  const content = `You are about to delete account ${element.account_id} with email ${element.email}\nAre you sure?${managerWarning}`;
                  this.store$.dispatch(openDialog({
                  dialogData: {
                    content,
                    title: `Delete account ${element.account_id}`,
                    canClose: true,
                    buttons: [
                      {
                        color: ButtonColor.RED,
                        text: 'Yes',
                        size: ButtonSize.NORMAL,
                        onClick: (dialog) => this.userService
                          .deleteUser(element.account_id)
                          .subscribe(response => {
                            this.store$.dispatch(openSnackbar({
                              snackbarData: {
                                data: {
                                  message: `Account ${element.account_id} deleted successfully`,
                                  type: 'success',
                                },
                              },
                            }));
                            dialog.closeDialog();
                            this.dataSource.refresh();
                          }, err => {
                            this.store$.dispatch(openSnackbar({
                              snackbarData: {
                                data: {
                                  message: err.error,
                                  type: 'error',
                                },
                              },
                            }));
                            dialog.closeDialog();
                          }),
                      },
                    ],
                  },
                }))
                } else {
                  this.store$.dispatch(openDialog({
                    dialogData: {
                      content: ManageDeletedAccountComponent,
                      title: `Delete account ${element.account_id}`,
                      componentData: {
                        account: element,
                        headerText: `You are about to delete account ${element.account_id} with email ${element.email}`,
                      },
                      canClose: true,
                      buttons: [
                        {
                          text: 'Delete',
                          color: ButtonColor.RED,
                          size: ButtonSize.NORMAL,
                          onClick: (dialog: DialogComponent) => {
                            if(!dialog.dialogForm.valid) {
                              dialog.dialogForm.markAllAsTouched();
                              dialog.releaseButtons();
                              return;
                            }

                            this.userService.deleteUser(element.account_id, dialog.dialogForm.value.deleted_forward, dialog.dialogForm.value.period)
                              .subscribe(response => {
                                this.store$.dispatch(openSnackbar({
                                  snackbarData: {
                                    data: {
                                      message: `Account ${element.account_id} deleted successfully`,
                                      type: 'success',
                                    },
                                  },
                                }));
                                dialog.closeDialog();
                                this.dataSource.refresh();
                              }, err => {
                                this.store$.dispatch(openSnackbar({
                                  snackbarData: {
                                    data: {
                                      message: err.error,
                                      type: 'error',
                                    },
                                  },
                                }));
                                dialog.closeDialog();
                              });
                          }
                        }
                      ]
                    }
                  }));
                }
              },
              size: ButtonSize.SMALL,
            },
          },
          {
            id: 'manager_id',
            title: 'Manager',
            type: ETableColumnType.BUTTON,
            disabled: session.user_type !== UserType.MASTER,
            getButtonProperties: (row: IAccount) => {
              let buttonText = !!row.manager_id ? 'Change Manager' : 'Add Manager';
              let buttonColor = ButtonColor.ORANGE;

              if (row.account_role === UserType.MANAGER) {
                buttonText = 'View Reps';
              } else if (row.account_role === UserType.SINGLE_USER) {
                buttonColor = ButtonColor.GREEN;
              }
              return {
                text: buttonText,
                color: buttonColor,
                buttonDisabled: (row1: IAccount) => row1.account_role === UserType.VSM || row1.account_role === UserType.PARTNER || row1.account_role === UserType.MASTER,
                size: ButtonSize.NORMAL,
                onClick: (row2: IAccount) => this.store$.dispatch(openDialog({
                  dialogData: {
                    content: ManagerSelectDialogComponent,
                    componentData: {
                      user: row2,
                      managers: this.managers,
                      currentUser: session,
                    },
                    title: row2.account_role !== UserType.MANAGER ? 'Select Manager' : 'Managed Users',
                    canClose: true,
                    dialogMinWidth: '900px',
                    buttons: row2.account_role === UserType.SINGLE_USER ? [
                      {
                        text: 'Save',
                        color: ButtonColor.BLUE,
                        size: ButtonSize.NORMAL,
                        onClick: dialog => {
                          if (row2.account_role !== UserType.SINGLE_USER) {
                            dialog.closeDialog();
                            return;
                          }
                          if (!dialog.dialogForm.valid) {
                            dialog.dialogForm.markAllAsTouched();
                            dialog.releaseButtons();
                            return;
                          }

                          const data = dialog.dialogForm.value;

                          if (data.manager_id === '') {
                            data.manager_id = null;
                          }

                          dialog.lockButtons();
                          this.setAccountManager(row2, data, dialog);
                        },
                      },
                    ] : [],
                  },
                })),
              };
            },
          },
        ];
        if (session.user_type === UserType.MASTER) {
          this.tableColumns = [
            ...this.tableColumns,
            {
              id: 'subscription',
              title: 'Subscription',
              type: ETableColumnType.BUTTON,
              getButtonProperties: (row: IAccount) => ({
                text: !row.invoiced ? 'Manage' : 'Invoiced',
                buttonDisabled: (a: IAccount) => a.invoiced || ([UserType.MASTER, UserType.FRANCHISE].indexOf(a.account_role) !== -1),
                color: row.legacy_stripe ? ButtonColor.PURPLE : ButtonColor.ORANGE,
                size: ButtonSize.NORMAL,
                onClick: () => this.manageSubscription(row),
              }),
            },
            {
              id: 'partner_id',
              title: 'Partner',
              type: ETableColumnType.COMPONENT,
              componentProperties: {
                component: PartnerControlComponent,
                mapData: {
                  column: {
                    instance: 'column',
                  },
                  partners: {
                    instance: 'static',
                    target: this.partners,
                  },
                },
              },
            },
            {
              id: 'franchisee_id',
              title: 'Franchisee',
              type: ETableColumnType.COMPONENT,
              componentProperties: {
                component: FranchiseeControlComponent,
                mapData: {
                  column: {
                    instance: 'column',
                  },
                  franchisees: {
                    instance: 'static',
                    target: this.franchisees,
                  },
                },
              },
            },
            {
              id: 'vsc_id',
              title: 'Edge',
              type: ETableColumnType.COMPONENT,
              componentProperties: {
                component: VsmControlComponent,
                mapData: {
                  column: {
                    instance: 'column',
                  },
                  vsms: {
                    instance: 'static',
                    target: this.vsms,
                  },
                },
              },
            },
          ];
        }

        if (session.user_type === UserType.FRANCHISE) {
          this.tableColumns = [
            ...this.tableColumns,
            {
              id: 'referral_partner_id',
              title: 'Referral',
              type: ETableColumnType.COMPONENT,
              componentProperties: {
                component: ReferralPartnerControlComponent,
                mapData: {
                  column: {
                    instance: 'column',
                  },
                  referralPartners: {
                    instance: 'static',
                    target: this.referralPartners,
                  },
                  franchiseeId: {
                    instance: 'static',
                    target: this.sessionFranchiseeId,
                  },
                },
              },
            },
          ];
        }

        this.tableReady$.next(true);
      });
    });
  }

  private setAccountManager(row2: IAccount, data: any, dialog: DialogComponent, confirm: boolean = false) {
    this.accountService
      .setAccountManager(row2.account_id, data.manager_id, data.paid_by === SUBSCRIPTION_PAID_BY_MANAGER, confirm)
      .subscribe(
        response => {
          if (response instanceof HttpErrorResponse) {
            dialog.releaseButtons();
            this.store$.dispatch(
              openSnackbar({
                snackbarData: {
                  data: {
                    message: response.error,
                    type: 'error',
                  },
                },
              }),
            );
            return;
          }
          dialog.closeDialog();
          this.dataSource.refresh();
          this.store$.dispatch(
            openSnackbar({
              snackbarData: {
                data: {
                  message: 'Account settings successfully changed',
                  type: 'success',
                },
              },
            }),
          );
        },
        error => {
          if (error instanceof HttpErrorResponse && error.error && error.error.code === 1002) {
            let confirmationAccepted = false;
            this.store$.dispatch(openDialog({
              dialogData: {
                content: error.error.message[0],
                title: 'Please, confirm',
                canClose: true,
                closeButtonText: 'No',
                onClose: () => {
                  if (!confirmationAccepted) {
                    dialog.releaseButtons();
                  }
                },
                onCloseButton: dialog2 => {
                  dialog2.closeDialog();
                },
                buttons: [
                  {
                    text: 'Yes',
                    color: ButtonColor.ORANGE,
                    size: ButtonSize.NORMAL,
                    onClick: dialog2 => {
                      confirmationAccepted = true;
                      dialog2.closeDialog();
                      this.setAccountManager(row2, data, dialog, true);
                    },
                  },
                ],
              },
            }));
            return;
          }
          dialog.releaseButtons();
          this.store$.dispatch(
            openSnackbar({
              snackbarData: {
                data: {
                  message: error.error,
                  type: 'error',
                },
              },
            }),
          );
        },
      );
  }

  private getActionLabel(action: string, row?: IAccount): string {
    if (action === 'confirmAndMark' && row.confirmed_at) {
      return 'Mark invoiced';
    }
    return this.adminActionsLabelMap[action] || action;
  }

  private manageSubscription(row: IAccount) {
    this.store$.dispatch(openDialog({
      dialogData: {
        title: 'Manage subscription for ' + row.email,
        content: ManageSubscriptionDialogComponent,
        componentData: {
          account: row,
        },
        canClose: true,
        buttons: [
          {
            text: 'Save',
            color: ButtonColor.GREEN,
            size: ButtonSize.NORMAL,
            onClick: (dialog: DialogComponent) => this.updateSubscription(row, dialog),
          },
        ],
      },
    }));
  }

  private removeSubscription(row: IAccount, dialog: DialogComponent) {
    const component: ManageSubscriptionDialogComponent = dialog.component;

    if (!component.hasSubscription) {
      this.store$.dispatch(openSnackbar({
        snackbarData: {
          data: {
            message: 'There is no subscription to remove. Closing the dialog!',
            type: 'error',
          },
        },
      }));
      dialog.closeDialog();

      return;
    }

    this.subscriptionService.update(row.account_id, {
      discard_discount: true,
    }).subscribe(result => {
      dialog.closeDialog();
      this.store$.dispatch(openSnackbar({
        snackbarData: {
          data: {
            message: 'The discount is discarded successfully!',
            type: 'success',
          },
        },
      }));
      this.dataSource.refresh();
    }, err => {
      this.store$.dispatch(openSnackbar({
        snackbarData: {
          data: {
            message: err.error,
            type: 'error',
          },
        },
      }));
      dialog.closeDialog();
    });
  }

  private updateSubscription(row: IAccount, dialog: DialogComponent) {
    if (!dialog.dialogForm.valid) {
      dialog.dialogForm.markAllAsTouched();
      return;
    }
    const data = dialog.dialogForm.value;
    if (data.discard_discount) {
      delete data.discount;
    }
    this.subscriptionService.update(row.account_id, data).subscribe(result => {
      dialog.closeDialog();
      this.store$.dispatch(openSnackbar({
        snackbarData: {
          data: {
            message: 'The subscription was successfully updated!',
            type: 'success',
          },
        },
      }));
      this.dataSource.refresh();
    }, err => {
      this.store$.dispatch(openSnackbar({
        snackbarData: {
          data: {
            message: err.error,
            type: 'error',
          },
        },
      }));
    });
  }
}
